import { Box, Typography, useTheme } from '@mui/material';

import { Button, Tooltip } from '@verantos-dev/shared-components';

export type CohortSectionPrimaryAction = {
  label: string;
  onClick: () => void;
  disabled?: boolean;
  labelIcon?: string;
  tooltipText?: string;
};

export type CohortSectionHeaderProps = {
  /**
   * @prop {string} - The title of the section
   */
  title: string;

  action?: CohortSectionPrimaryAction;
};

export const CohortSectionHeader = ({ title, action }: CohortSectionHeaderProps) => {
  const theme = useTheme();

  return (
    <Box
      data-testid={'cohortSectionHeader'}
      sx={{
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        justifyContent: 'space-between',
        mb: `${theme.spacing(6)}`,
      }}
    >
      <Typography variant="h6">{title}</Typography>
      {action && (
        <Tooltip id={'cohortSectionHeaderTooltip'} title={action.tooltipText} arrow width={'auto'}>
          <Box component="span">
            <Button
              id="cohortSectionHeaderActionBtn"
              btnType="secondary"
              startIcon={action.labelIcon}
              onClickHandler={() => !action.disabled && action.onClick()}
              disabled={action.disabled}
              displayLabel={action.label}
            />
          </Box>
        </Tooltip>
      )}
    </Box>
  );
};
